import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {  Button, Grid, Typography, Container, CardMedia } from '@material-ui/core';
import { Facebook, YouTube, Instagram, LinkedIn } from '@material-ui/icons';
import dev from './dev.png'
import Parallax from 'react-rellax'
export const Resume = () => {
    const classes = useStyles();

    return (
        <React.Fragment>

            <main className={classes.root}>
                {/* Hero unit */}
                <div className={classes.heroContent}>
                    <Container maxWidth="lg">
                        <Grid container spacing={1}>
                            <Grid item lg={8} md={7}>
                                <Typography variant="h5" align="left" color="textPrimary" gutterBottom>
                                    Hi, my name is
                        </Typography>
                                <Typography variant="h1" align="center" color="textPrimary" component="p" align='left'>
                                    Abaid Butt.
                        </Typography>
                                <Typography variant='h2' color='textSecondary' align='left'>
                                    I build things for the web.
                        </Typography>
                                <Typography variant='h6' align='left'>
                                    I'm a software engineer based in Agriculture, MSCS specializing in<br /> building (and occasionally designing) exceptional websites,<br /> appications, and everthing in between.
                        </Typography>
                            </Grid>
                            <Grid item lg={4} md={5}>
                                <Parallax speed={3}>
                                    <CardMedia
                                        image={dev}
                                        title="Contemplative Reptile"
                                        component="img"
                                        className={classes.media}

                                    />


                                    {/* <img
                                        src={dev}
                                        title="Live from space album cover"

                                    /> */}
                                </Parallax>
                            </Grid>

                        </Grid>


                        <div className={classes.heroButtons}>
                            <Grid container spacing={2} justify="center">
                                <Grid item>
                                    <Button variant="contained" color="primary">
                                        <Facebook />
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="outlined" color="primary">
                                        <LinkedIn />
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="outlined" color="primary">
                                        <YouTube />
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="outlined" color="primary">
                                        <Instagram />
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </div>

                

            </main>
        </React.Fragment>
    );
}
const useStyles = makeStyles((theme) => ({
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
        display: 'flex',
        minHeight: '100vh',
        margin: 'auto',
        [theme.breakpoints.between('sm', 'md')]: {
            minHeight:'60vh'
        },


        // backgroundImage: `url(${computer})`,
        // backgroundRepeat: 'no-repeat',
        // backgroundColor:
        //     theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        // backgroundSize: 'cover',
        // backgroundPosition: 'center',

    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    content: {
        flex: '1 0 auto',
        textAlign: 'left'
    },
    footer: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(6),
    },
    media: {
        height: '600',
        [theme.breakpoints.between('sm', 'md')]: {
            display: 'flex',
            alignContent: 'flex-end',
            marginLeft: theme.spacing(20),
        },


    },
}));
